/* eslint-disable react/destructuring-assignment */

import * as React from 'react';
import { BaseFieldProps, Field } from 'redux-form';
import { WrappedFieldProps } from 'redux-form/lib/Field';

import styles from './appFormField.module.scss';
import * as FormValidations from './formValidations';

export interface AppFormFieldOwnProps extends BaseFieldProps {
  disabled?: boolean;
  label?: any;
  placeholder?: string;
  type?: string;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  readonly?: boolean;
  hiddenLabel?: boolean;
  value?: any;
}

export interface AppFormFieldProps extends WrappedFieldProps {
  label?: string;
  disabled?: boolean;
}

const normalize = (inputType: string, normalizer: Function) => (value: any, ...args: any[]) => {
  if (typeof value !== 'undefined' && value.length !== 0) {
    if (inputType === 'number') {
      return parseFloat(value);
    }

    if (typeof normalizer === 'function') {
      normalizer(value, ...args);
    }
  }

  return value;
};

export abstract class AppFormField<
  OwnProps extends AppFormFieldOwnProps = AppFormFieldOwnProps
> extends React.Component<OwnProps> {
  private componentRender = this.renderField.bind(this);

  public render() {
    return (
      // @ts-ignore
      <Field
        {...this.props}
        component={this.componentRender}
        normalize={normalize(this.props.type, this.props.normalize)}
      />
    );
  }

  // eslint-disable-next-line react/sort-comp
  protected abstract renderInput(field: AppFormFieldProps): JSX.Element;

  // noinspection JSMethodCanBeStatic
  protected isFieldInvalid(field: AppFormFieldProps) {
    return field.meta.touched && field.meta.error;
  }

  private renderField(field: any): JSX.Element {
    const className = `${styles.appFormField} ${this.isFieldInvalid(field) ? styles.error : ''} 
    ${this.props.className || ''}`;

    return (
      <>
        <div className={className}>
          {this.props.hiddenLabel || this.renderLabelWrapper(field)}
          {this.renderInputWrapper(field)}
        </div>
      </>
    );
  }

  // eslint-disable-next-line no-unused-vars
  private renderLabelWrapper(field: AppFormFieldProps) {
    return (
      <div className={`${styles.labelWrapper} ${this.props.labelClassName || ''}`}>
        {this.props.label}
        {this.isRequired() && <span>*</span>}
      </div>
    );
  }

  private renderInputWrapper(field: AppFormFieldProps) {
    return (
      <div className={`${styles.inputWrapper} ${this.props.inputClassName || ''}`}>
        <div className={styles.field}>{this.renderInput(field)}</div>
        {this.renderErrorWrapper(field)}
      </div>
    );
  }

  private renderErrorWrapper(field: AppFormFieldProps) {
    const hasError = this.isFieldInvalid(field);

    if (!hasError) {
      return null;
    }

    return <div className={styles.errorWrapper}>{field.meta.error}</div>;
  }

  private isRequired() {
    if (!this.props.validate) {
      return false;
    }

    if (Array.isArray(this.props.validate)) {
      return this.props.validate.indexOf(FormValidations.required) >= 0;
    }

    return this.props.validate === FormValidations.required;
  }
}
